import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Send } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-surface" data-id="element-42" data-mp="356ltveutuh7f">
      <div className="max-w-7xl mx-auto px-6" data-id="element-43" data-mp="3161ue4ms71i4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-44" data-mp="316tpzfgdoz8e">
          {/* Left Column: Map */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full h-[400px] lg:h-[500px] rounded-3xl overflow-hidden border border-border shadow-lg" data-id="element-45" data-mp="2w9tjx4jj3wha">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2540.485600297871!2d30.52125557685651!3d50.45068228729115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce50f8b6e3c3%3A0xb528dc4d6bfc05cb!2sKhreshchatyk%20St%2C%2015%2C%20Kyiv%2C%20Ukraine%2C%2002000!5e0!3m2!1sen!2sus!4v1716380000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map" data-id="element-46" data-mp="3f62x7pmlwj08"></iframe>
          </motion.div>

          {/* Right Column: Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-47" data-mp="3646fw8qvcncr">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-48" data-mp="2w6a6pmhhs2ha">
              Потрібна консультація?
            </h2>
            <p className="text-secondary mb-12 text-lg leading-relaxed" data-id="element-49" data-mp="uenclc2azrgl">
              Залиште свої контакти, оберіть напрямок, що вас цікавить, і ми
              зв'яжемося з вами протягом 15 хвилин для первинного розбору
              ситуації. Ви також можете зателефонувати нам або завітати до
              офісу.
            </p>

            <div className="space-y-8" data-id="element-50" data-mp="1ua480tqthv94">
              <div className="flex items-start gap-5" data-id="element-51" data-mp="1ud038aba65tv">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-52" data-mp="1pcktrtu4dih6">
                  <MapPin size={22} data-id="element-53" data-mp="2m3wghc196cho" />
                </div>
                <div data-id="element-54" data-mp="2i1rp6jya1ry7">
                  <h4 className="font-medium text-primary mb-1" data-id="element-55" data-mp="2i19uvsv6dnsx">Наша адреса</h4>
                  <p className="text-secondary" data-id="element-56" data-mp="2d8gqj63mchhd">
                    вул. Хрещатик, 15, Київ, Україна
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-57" data-mp="35qkomqe3yhxk">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-58" data-mp="35rdqbcy7mh8u">
                  <Phone size={22} data-id="element-59" data-mp="38baawfwaayso" />
                </div>
                <div data-id="element-60" data-mp="38ctsc9toffw1">
                  <h4 className="font-medium text-primary mb-1" data-id="element-61" data-mp="3d9bs0va5go1i">Телефон</h4>
                  <a href="tel:+380932099273" className="text-secondary hover:text-primary transition-colors" data-id="element-62" data-mp="3dbeu4doku7ml">
                    +380 93 209 92 73
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-63" data-mp="3r8tn1se1gxjb">
                <div className="w-12 h-12 rounded-2xl bg-background border border-border flex items-center justify-center text-primary flex-shrink-0" data-id="element-64" data-mp="2igjgq9f4kl">
                  <Send size={22} data-id="element-65" data-mp="4ujztmluhvk4" />
                </div>
                <div data-id="element-66" data-mp="9t4qaubap0vd">
                  <h4 className="font-medium text-primary mb-1" data-id="element-67" data-mp="9rjwx80pvnz3">
                    Telegram
                  </h4>
                  <a href="https://t.me/Advokat_Andriy" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors" data-id="element-68" data-mp="dw9s0unjwyiy">
                    @Advokat_Andriy
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}